import InputBase from "@material-ui/core/InputBase";
import React, { useEffect } from "react";
import SearchIcon from "@material-ui/icons/Search";
import { fade, makeStyles } from "@material-ui/core";
import { useDataLayerValue } from "../../Reducer/DataLayer";
import Card60 from "../ScrollHome/Card60";
import Card220 from "../ScrollHome/Card220";

function AllNews() {
  const classes = useStyles();
  const [{ allNews, isMobile }, dispatch] = useDataLayerValue();

  useEffect(() => {
    (async () => {
      try {
        const _token = localStorage.getItem("userToken");

        const response = await fetch("/.netlify/functions/server/api/allNews", {
          headers: {
            authorization: `Bearer ${_token}`,
          },
        });
        const data = await response.json();
        // console.log(data);
        await dispatch({
          type: "ADD_ALL_NEWS",
          payload: { allNews: data },
        });
        await dispatch({
          type: "ADD_STORIES",
          payload: { stories: data?.slice(0, 9) },
        });
      } catch (err) {
        console.error(err.messaage);
      }
    })();

    var isMobile = navigator.userAgent.split(" ");
    isMobile =
      isMobile.indexOf("Android") !== -1 || isMobile.indexOf("iPhone") !== -1;
    dispatch({
      type: "SET_MOBILE",
      payload: { isMobile },
    });
  }, []);

  console.log(allNews);
  const [isOpen, setIsOpen] = React.useState(0);

  return (
    <div className={classes.root}>
      <div className={classes.rootTop}>
        <div className={classes.search}>
          <InputBase
            placeholder="Search.... "
            classes={{
              root: classes.inputRoot,
              input: classes.inputInput,
            }}
            className={classes.searchInput}
            inputProps={{ "aria-label": "search" }}
          />
          <div className={classes.searchIcon}>
            <SearchIcon />
          </div>
        </div>
        <div className={classes.filters}>Filters</div>
      </div>
      <div className={classes.rootMiddle}>
        {allNews?.map((news) => (
          <div key={news?.news_id} onClick={() => setIsOpen(news?.news_id)}>
            {isOpen === news?.news_id ? (
              <Card220 news={news} />
            ) : (
              <Card60 news={news} />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default AllNews;

const useStyles = makeStyles((theme) => ({
  rootTop: {
    display: "flex",
    columnGap: ".5rem",
    padding: ".5rem",
    flexDirection: "column",
    backgroundColor: "grey",
    [theme.breakpoints.up("sm")]: {
      flexDirection: "row",
    },
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    display: "flex",
    width: "auto",
    [theme.breakpoints.up("sm")]: {
      flex: "1 0 auto",
    },
  },
  searchIcon: {
    borderRadius: "0 .3rem .3rem 0",
    backgroundColor: fade(theme.palette.common.black, 0.3),
    color: fade(theme.palette.common.white, 0.9),
    padding: theme.spacing(0, 2),
    height: "100%",
    alignSelf: "center",
    pointerEvents: "none",
    justifyContent: "center",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "flex-end",
      cursor: "pointer",
      justifySelf: "right",
    },
    "& svg": {
      margin: "20% 0",
    },
  },
  searchInput: {
    borderRadius: ".3rem 0 0 .3rem",
    backgroundColor: fade(theme.palette.common.black, 0.15),
    "&:hover": {
      backgroundColor: fade(theme.palette.common.black, 0.25),
    },
    width: "100%",
    paddingLeft: ".5rem",
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
  },
  filters: {
    flex: "1 0 auto",
    width: "inherit",
    backgroundColor: "red",
  },

  rootMiddle: {
    backgroundColor: "green",
    height: "inherit",
  },
}));
